module.exports = __webpack_public_path__ + "img/backrest_carriage_interface_references.2880bd8b.jpg";